import lf from 'lovefield'

export function const_engins_const_parametresmateriels (schemaBuilder) {
  schemaBuilder.createTable('const_engins_const_parametresmateriels')
    .addColumn('id', lf.Type.INTEGER)
    .addColumn('const_engins_id', lf.Type.INTEGER)
    .addColumn('const_parametresmateriels_id', lf.Type.INTEGER)
    .addColumn('data', lf.Type.NUMBER)
    .addColumn('annee', lf.Type.INTEGER)
    .addPrimaryKey(['id'])
}

/*--
CREATE TABLE IF NOT EXISTS `const-engins_const-parametresmateriels` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `const-engins_id` int(11) NOT NULL,
  `const-parametresmateriels_id` int(11) NOT NULL,
  `data` float NOT NULL,
  `annee` int(4) NOT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=53 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constEngins_constParametresmateriels.schema.js